import React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

import {colors} from '../styles';
import {Text, TextStyle} from './Typography';

interface SeparatorProps {
  text?: string;
  textStyle?: TextStyle;
  style?: StyleProp<ViewStyle>;
}

export const Separator: React.FC<SeparatorProps> = ({
  style,
  text,
  textStyle,
}) => (
  <View style={[styles.container, style]}>
    <View style={styles.line} />

    <Text variant="s" style={[styles.text, textStyle]}>
      {text}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  line: {
    position: 'absolute',
    width: '100%',
    height: 1,
    backgroundColor: colors.darkGreyMedium33,
  },
  text: {
    backgroundColor: colors.black,
    paddingHorizontal: 8,
    zIndex: 1,
    textTransform: 'lowercase',
  },
});
